// Import necessary modules and hooks from React and React Router
import { Navigate, Outlet } from "react-router";
import { useAuthContext } from "../../../contexts/AuthContext";
import { useEffect, useState } from "react";

// Define a component named ProtectedRoute that receives a prop called redirectPath with a default value '/'
export const ProtectedRoute = ({ redirectPath = '/' }) => {
    // Use the useAuthContext() hook to get the user and token checking function from the authentication context
    const { user, checkToken, zones } = useAuthContext();

    // Define a state to store the token from localStorage
    const [token, setToken] = useState(localStorage.getItem('unified_videowall_cascais_token'));

    // Define an effect to check the token when the component is mounted
    useEffect(() => {
        if (token) {
            checkToken(); // Call the function to check the token
        }
    }, [])

    // Define an effect to update the token state when the user changes
    useEffect(() => {
        // If there is no token in localStorage, set the token to null
        if (!localStorage.getItem('unified_videowall_cascais_token')) {
            setToken(null);
        }
    }, [user]) // Dependency of the effect, this effect will be triggered when the user changes

    // If there is no token, redirect to the route specified in the redirectPath prop
    if (!token) {
        return <Navigate to={redirectPath} replace />;
    }

    // If there is a token, render the Outlet component which will render nested routes
    return <Outlet />
};